import script from "./MainPage_JPN.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPage_JPN.vue?vue&type=script&setup=true&lang=ts"

import "./MainPage_JPN.vue?vue&type=style&index=0&id=f9f1c322&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9f1c322"]])

export default __exports__